import { ImageConverterPageTemplateInterface } from "./ImageConverterPageTemplateInterface";

export const imageConverterJsonTemplate: ImageConverterPageTemplateInterface = {
    meta: {
        pageTitle: "page-title",
        metaDescription: "meta-description",
        metaKeywords: "meta-keywords",
    },
    section1: {
        section1Title: "section-1-title",
        section1SubTitle: "section-1-sub-title",
    },
    section2: {
        section2CtaWording1: "section-2-cta-wording-1",
        section2CtaWording2: "section-2-cta-wording-2",
    },
    section3: {
        items: [
            {
                title: "section-3-title-1",
                subTitle: "section-3-sub-title-1",
                icon: "award",
            },
            {
                title: "section-3-title-2",
                subTitle: "section-3-sub-title-2",
                icon: "file-input",
            },
            {
                title: "section-3-title-3",
                subTitle: "section-3-sub-title-3",
                icon: "zap",
            },
            {
                title: "section-3-title-4",
                subTitle: "section-3-sub-title-4",
                icon: "layers",
            },
            {
                title: "section-3-title-5",
                subTitle: "section-3-sub-title-5",
                icon: "gift",
            },
            {
                title: "section-3-title-6",
                subTitle: "section-3-sub-title-6",
                icon: "shield-check",
            },
        ],
    },
    section4: {
        title: "section-4-title",
        subTexts: ["section-4-sub-text-1", "section-4-sub-text-2", "section-4-sub-text-3", "section-4-sub-text-4"],
    },
    section5: {
        title: "section-5-title",
        subTitle: "section-5-sub-title",
        graphics: "/images/image-converter-section-5-image.webp",
    },
    section6: {
        title: "section-6-title",
        subTitle: "section-6-sub-title",
        graphics: "/images/image-converter-section-6-image.webp",
    },
    // section7: {
    //     title: "section-7-title",
    //     subSection1Title: "section-7-sub-section-1-title",
    //     subSection1Subtitle: "section-7-sub-section-1-sub-title",
    //     subSection1Links: [
    //         {
    //             title: "section-7-sub-section-1-link-1-title",
    //             url: "section-7-sub-section-1-link-1-url",
    //         },
    //     ],
    //     subSectionTitle: "section-7-sub-section-2-title",
    //     subSectionSubTitle: "section-7-sub-section-2-sub-title",
    //     subSection2Links: [
    //         {
    //             title: "section-7-sub-section-1-link-1-title",
    //             url: "section-7-sub-section-1-link-1-url",
    //         },
    //     ],
    // },
    section8: {
        title: "section-8-title",
        items: [
            {
                title: "section-8-item-1-title",
                subTitle: "section-8-item-1-sub-title",
                icon: "thumbs-up",
            },
            {
                title: "section-8-item-2-title",
                subTitle: "section-8-item-2-sub-title",
                icon: "layers",
            },
            {
                title: "section-8-item-3-title",
                subTitle: "section-8-item-3-sub-title",
                icon: "heart",
            },
            {
                title: "section-8-item-4-title",
                subTitle: "section-8-item-4-sub-title",
                icon: "images",
            },
        ],
    },
    section10: {
        title: "section-10-faq-title",
        subTitle: "section-10-faq-sub-title",
        items: [
            {
                question: "section-10-faq-item-1-question",
                answer: "section-10-faq-item-1-answer",
            },
            {
                question: "section-10-faq-item-2-question",
                answer: "section-10-faq-item-2-answer",
            },
            {
                question: "section-10-faq-item-3-question",
                answer: "section-10-faq-item-3-answer",
            },
            {
                question: "section-10-faq-item-4-question",
                answer: "section-10-faq-item-4-answer",
            },
            {
                question: "section-10-faq-item-5-question",
                answer: "section-10-faq-item-5-answer",
            },
            {
                question: "section-10-faq-item-6-question",
                answer: "section-10-faq-item-6-answer",
            },
            {
                question: "section-10-faq-item-7-question",
                answer: "section-10-faq-item-7-answer",
            },
            {
                question: "section-10-faq-item-8-question",
                answer: "section-10-faq-item-8-answer",
            },
            {
                question: "section-10-faq-item-9-question",
                answer: "section-10-faq-item-9-answer",
            },
            {
                question: "section-10-faq-item-10-question",
                answer: "section-10-faq-item-10-answer",
            },
            {
                question: "section-10-faq-item-11-question",
                answer: "section-10-faq-item-11-answer",
            },
            {
                question: "section-10-faq-item-12-question",
                answer: "section-10-faq-item-12-answer",
            },
            {
                question: "section-10-faq-item-13-question",
                answer: "section-10-faq-item-13-answer",
            },
            {
                question: "section-10-faq-item-14-question",
                answer: "section-10-faq-item-14-answer",
            },
            {
                question: "section-10-faq-item-15-question",
                answer: "section-10-faq-item-15-answer",
            },
        ],
    },
    section11: {
        title: "section-11-title",
        subTitle: "section-11-sub-title",
    },
};
